import { render, staticRenderFns } from "./StorePoster.vue?vue&type=template&id=5f1c8ae0&scoped=true&"
import script from "./StorePoster.vue?vue&type=script&lang=js&"
export * from "./StorePoster.vue?vue&type=script&lang=js&"
import style0 from "./StorePoster.vue?vue&type=style&index=0&id=5f1c8ae0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1c8ae0",
  null
  
)

export default component.exports